import { Injectable } from '@angular/core';
import {
  safeStorageGet,
  safeStorageRemove,
  safeStorageSet,
} from '../shared/utils/safe-storage';

// Domain helper for array-valued localStorage keys (e.g. the list of Firebase
// app instance names). Built on the safe-storage primitives so a blocked-storage
// browser degrades to an empty array instead of throwing.
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  getArray(key: string): string[] {
    const raw = safeStorageGet(key);
    if (!raw) {
      this.setArray(key, []);
      return [];
    }
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  setArray(key: string, array: string[]): void {
    safeStorageSet(key, JSON.stringify(array));
  }

  addItemToArray(key: string, item: string): void {
    const array = this.getArray(key);
    if (!array.includes(item)) {
      array.push(item);
      this.setArray(key, array);
    }
  }

  deleteArray(key: string): void {
    safeStorageRemove(key);
  }
}
